import React from "react"
import styled, { css } from "styled-components"

const HamburgerMenu = ({ active, onClick }) => {
  return (
    <Wrapper active={active} onClick={onClick} aria-label="Menu">
      <span className="hamburger__container" tabIndex="-1">
        <span className="hamburger__bars"></span>
      </span>
    </Wrapper>
  )
}

export default HamburgerMenu

const Wrapper = styled.button`
  margin: 0;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;

  &:focus {
    & > .hamburger__container {
      box-shadow: 0 0 2px 2px #51a7e8;
    }
  }

  .hamburger__container {
    &:focus {
      outline: none;
    }
  }

  .hamburger__container {
    display: flex;
    align-items: center;
    position: relative;
    width: 30px;
    height: 25px;
  }

  .hamburger__bars {
    position: absolute;
    width: 30px;
    height: 2px;
    background-color: ${({ theme }) => theme.color.second};
    transition: transform 220ms ease-in-out;
    border-radius: 2px;

    &::before,
    &::after {
      display: block;
      position: absolute;
      width: 30px;
      height: 2px;
      background-color: ${({ theme }) => theme.color.second};
      content: "";
      border-radius: 2px;
    }

    &::before {
      top: -10px;
      transition: top 100ms 250ms ease-in, transform 220ms ease-in-out;
    }

    &::after {
      bottom: -10px;
      transition: bottom 100ms 250ms ease-in, transform 220ms ease-in-out;
    }
  }

  ${({ active }) =>
    active &&
    css`
      .hamburger__bars {
        transform: rotate(225deg);
        transition: transform 220ms 120ms ease-in-out;

        &::before {
          top: 0;
          transition: top 100ms ease-out;
        }

        &::after {
          bottom: 0;
          transform: rotate(-90deg);
          transition: bottom 100ms ease-out, transform 220ms 120ms ease-in-out;
        }
      }
    `}
`
